import { parseTenantActivationFilters, type TenantActivationFilters } from "./activation-filters";

/**
 * Which slice of a tenant's signals a list shows — the activation list's
 * filters, bounding the signal's `receivedDateTime` rather than an activation's
 * `createdDateTime`. The same because the endpoints share one query schema:
 * see `ListTenantSignalsQueryParams`.
 */
export type TenantSignalFilters = TenantActivationFilters;

/** Reads signal list filters from raw URL params, refusing what the signal endpoint would refuse. */
export const parseTenantSignalFilters = parseTenantActivationFilters;
